import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7087/Support";
	}
	getAgentIntegrationStatus(e, t, n) {
		let r = this.baseUrl + "/GetAgentIntegrationStatus?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (r += "agencyId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		r += "agentId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgentIntegrationStatus(e)));
	}
	processGetAgentIntegrationStatus(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data, i = null;
			return i = r, w("Payload of String", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	resetAgentIntegration(e, t, n, r) {
		let i = this.baseUrl + "/ResetAgentIntegration?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (i += "agencyId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		if (i += "agentId=" + encodeURIComponent("" + t) + "&", n == null) throw new globalThis.Error("The parameter 'provider' must be defined and cannot be null.");
		i += "provider=" + encodeURIComponent("" + n) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "POST",
			url: i,
			headers: {},
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processResetAgentIntegration(e)));
	}
	processResetAgentIntegration(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 204) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data, i = null;
			return i = r, w("Payload of String", t, r, n, i);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getCommonInformationForMessage(e, t, n, r, i) {
		let a = this.baseUrl + "/GetCommonInformationForMessage?";
		if (e === null) throw new globalThis.Error("The parameter 'agentId' cannot be null.");
		if (e !== void 0 && (a += "agentId=" + encodeURIComponent("" + e) + "&"), t === null) throw new globalThis.Error("The parameter 'agencyId' cannot be null.");
		if (t !== void 0 && (a += "agencyId=" + encodeURIComponent("" + t) + "&"), n === null) throw new globalThis.Error("The parameter 'campaignId' cannot be null.");
		if (n !== void 0 && (a += "campaignId=" + encodeURIComponent("" + n) + "&"), r === null) throw new globalThis.Error("The parameter 'userId' cannot be null.");
		r !== void 0 && (a += "userId=" + encodeURIComponent("" + r) + "&"), a = a.replace(/[?&]$/, "");
		let o = {
			method: "GET",
			url: a,
			headers: { Accept: "application/json" },
			signal: i
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(a, e, (e) => this.processGetCommonInformationForMessage(e)));
	}
	processGetCommonInformationForMessage(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getLogsForServiceAtPeriod(e, t, n) {
		let r = this.baseUrl + "/GetLogsForServiceAtPeriod?";
		if (e == null) throw new globalThis.Error("The parameter 'agxService' must be defined and cannot be null.");
		if (r += "agxService=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'timeToSearchNear' must be defined and cannot be null.");
		r += "timeToSearchNear=" + encodeURIComponent(t ? "" + t.toISOString() : "") + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetLogsForServiceAtPeriod(e)));
	}
	processGetLogsForServiceAtPeriod(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPoisonQueueMessages(e, t, n) {
		let r = this.baseUrl + "/GetPoisonQueueMessages?";
		if (e == null) throw new globalThis.Error("The parameter 'agxService' must be defined and cannot be null.");
		if (r += "agxService=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'queueName' must be defined and cannot be null.");
		r += "queueName=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetPoisonQueueMessages(e)));
	}
	processGetPoisonQueueMessages(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPoisonQueues(e) {
		let t = this.baseUrl + "/GetPoisonQueues";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetPoisonQueues(e)));
	}
	processGetPoisonQueues(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getManualDocuSignUpdateCampaignDetails(e, t) {
		let n = this.baseUrl + "/GetManualDocuSignUpdateCampaignDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetManualDocuSignUpdateCampaignDetails(e)));
	}
	processGetManualDocuSignUpdateCampaignDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getMigrations(e) {
		let t = this.baseUrl + "/GetMigrations";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetMigrations(e)));
	}
	processGetMigrations(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	startMigrationRun(e, t) {
		let n = this.baseUrl + "/StartMigrationRun";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStartMigrationRun(e)));
	}
	processStartMigrationRun(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	replayQueueMessage(e, t) {
		let n = this.baseUrl + "/ReplayQueueMessage";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processReplayQueueMessage(e)));
	}
	processReplayQueueMessage(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getSoftDeletedAgentsForAgency(e, t) {
		let n = this.baseUrl + "/GetSoftDeletedAgentsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetSoftDeletedAgentsForAgency(e)));
	}
	processGetSoftDeletedAgentsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	restoreSoftDeletedAgent(e, t) {
		let n = this.baseUrl + "/RestoreSoftDeletedAgent";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processRestoreSoftDeletedAgent(e)));
	}
	processRestoreSoftDeletedAgent(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getUpdateCampaignStatusDetails(e, t) {
		let n = this.baseUrl + "/GetUpdateCampaignStatusDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetUpdateCampaignStatusDetails(e)));
	}
	processGetUpdateCampaignStatusDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateCampaignStatus(e, t) {
		let n = this.baseUrl + "/UpdateCampaignStatus";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateCampaignStatus(e)));
	}
	processUpdateCampaignStatus(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getUpdateLegalNameCampaignDetails(e, t) {
		let n = this.baseUrl + "/GetUpdateLegalNameCampaignDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetUpdateLegalNameCampaignDetails(e)));
	}
	processGetUpdateLegalNameCampaignDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateVendorLegalName(e, t) {
		let n = this.baseUrl + "/UpdateVendorLegalName";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (T(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateVendorLegalName(e)));
	}
	processUpdateVendorLegalName(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return w("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return w("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.DocuSign = "DocuSign", e.RpData = "RpData", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.Activities = "Activities", e.Agencies = "Agencies", e.CampaignFlow = "CampaignFlow", e.Campaigns = "Campaigns", e.Docusign = "Docusign", e.Marketing = "Marketing", e.Migrator = "Migrator", e.Notifications = "Notifications", e.Pdf = "Pdf", e.Rex = "Rex", e.RpData = "RpData", e.Staff = "Staff", e.TitleSearch = "TitleSearch", e.IdentityVerification = "IdentityVerification", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Verbose = "Verbose", e.Information = "Information", e.Warning = "Warning", e.Error = "Error", e.Critical = "Critical", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.Sent = "Sent", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Sent = "Sent", e.Opened = "Opened", e.Signed = "Signed", e.Complete = "Complete", e.Declined = "Declined", e.AutoResponded = "AutoResponded", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.NotRun = "NotRun", e.InProgress = "InProgress", e.Successful = "Successful", e.Failed = "Failed", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Activities = "Activities", e.Agencies = "Agencies", e.CampaignFlow = "CampaignFlow", e.Campaigns = "Campaigns", e.Docusign = "Docusign", e.Marketing = "Marketing", e.Migrator = "Migrator", e.Notifications = "Notifications", e.PDF = "PDF", e.Rex = "Rex", e.RPData = "RPData", e.Staff = "Staff", e.TitleSearch = "TitleSearch", e.IdentityVerification = "IdentityVerification", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.AgreementDraft = "AgreementDraft", e.AgreementVendorSigning = "AgreementVendorSigning", e.AgreementAgentSigning = "AgreementAgentSigning", e.AgreementSignedByAllParties = "AgreementSignedByAllParties", e.AgreementSubmissionIncomplete = "AgreementSubmissionIncomplete", e.AgreementPendingCompliance = "AgreementPendingCompliance", e.ListingCurrent = "ListingCurrent", e.ListingUnderContract = "ListingUnderContract", e.ListingUnconditional = "ListingUnconditional", e.ListingSold = "ListingSold", e.ListingWithdrawn = "ListingWithdrawn", e;
}({}), C = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isSupportApiException = !0;
	static isSupportApiException(e) {
		return e.isSupportApiException === !0;
	}
};
function w(e, t, n, r, i) {
	throw i ?? new C(e, t, n, r, null);
}
function T(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var E = "support";
function D(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var O = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), D(r);
}, k = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[E] || `${e}/${E}`;
}, A = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = k(i), u = c, d = O(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(O(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, j = a({}), M = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = A(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(j.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, N = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(j), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getAgentIntegrationStatus",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== t || i[5] !== s ? (d = (n) => {
		let { signal: r } = n;
		return s.getAgentIntegrationStatus(e, t, r);
	}, i[3] = e, i[4] = t, i[5] = s, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, P = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getAgentIntegrationStatus",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, F = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(j), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, agentId: n, provider: r } = e;
		return a.resetAgentIntegration(t, n, r);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		resetAgentIntegration: u,
		resetAgentIntegrationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, I = (e, t, n, i, a) => {
	let s = r(19), c = a === void 0 ? !0 : a, l = o(j), d;
	s[0] !== t || s[1] !== e || s[2] !== n || s[3] !== i ? (d = [
		"getCommonInformationForMessage",
		e,
		t,
		n,
		i
	], s[0] = t, s[1] = e, s[2] = n, s[3] = i, s[4] = d) : d = s[4];
	let f = d, p;
	s[5] !== t || s[6] !== e || s[7] !== l || s[8] !== n || s[9] !== i ? (p = (r) => {
		let { signal: a } = r;
		return l.getCommonInformationForMessage(e, t, n, i, a);
	}, s[5] = t, s[6] = e, s[7] = l, s[8] = n, s[9] = i, s[10] = p) : p = s[10];
	let m = c && !!l, h;
	s[11] !== f || s[12] !== p || s[13] !== m ? (h = {
		queryKey: f,
		queryFn: p,
		enabled: m
	}, s[11] = f, s[12] = p, s[13] = m, s[14] = h) : h = s[14];
	let { data: g, isPending: _, isError: v } = u(h), y;
	return s[15] !== g || s[16] !== v || s[17] !== _ ? (y = {
		data: g,
		isPending: _,
		isError: v
	}, s[15] = g, s[16] = v, s[17] = _, s[18] = y) : y = s[18], y;
}, L = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i) => {
		await t.invalidateQueries({ queryKey: [
			"getCommonInformationForMessage",
			e,
			n,
			r,
			i
		] });
	}, e[0] = t, e[1] = n), n;
}, R = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(j), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getLogsForServiceAtPeriod",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getLogsForServiceAtPeriod(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, z = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getLogsForServiceAtPeriod",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, B = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(j), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getPoisonQueueMessages",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getPoisonQueueMessages(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, V = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getPoisonQueueMessages",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, H = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(j), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getPoisonQueues"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getPoisonQueues(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, U = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getPoisonQueues"] });
	}, e[0] = t, e[1] = n), n;
}, W = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(j), s;
	n[0] === e ? s = n[1] : (s = ["getManualDocuSignUpdateCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getManualDocuSignUpdateCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, G = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getManualDocuSignUpdateCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, K = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(j), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getMigrations"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getMigrations(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, q = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getMigrations"] });
	}, e[0] = t, e[1] = n), n;
}, J = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(j), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.startMigrationRun(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		startMigrationRun: u,
		startMigrationRunPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Y = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(j), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.replayQueueMessage(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		replayQueueMessage: u,
		replayQueueMessagePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, X = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(j), s;
	n[0] === e ? s = n[1] : (s = ["getSoftDeletedAgentsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getSoftDeletedAgentsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Z = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getSoftDeletedAgentsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, Q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(j), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.restoreSoftDeletedAgent(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		restoreSoftDeletedAgent: u,
		restoreSoftDeletedAgentPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, $ = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(j), s;
	n[0] === e ? s = n[1] : (s = ["getUpdateCampaignStatusDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUpdateCampaignStatusDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ee = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUpdateCampaignStatusDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, te = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(j), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateCampaignStatus(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateCampaignStatus: u,
		updateCampaignStatusPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ne = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(j), s;
	n[0] === e ? s = n[1] : (s = ["getUpdateLegalNameCampaignDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUpdateLegalNameCampaignDetails(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUpdateLegalNameCampaignDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, ie = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(j), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateVendorLegalName(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateVendorLegalName: u,
		updateVendorLegalNamePending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { m as AgxService, h as LogEntrySeverityLevel, g as ManualDocuSignUpdateEnvelopeDetailsStatus, _ as ManualDocuSignUpdateRecipientDetailsStatus, v as MigrationRunDetailsStatus, p as Provider, y as ReplayQueueMessageRequestService, j as SupportApiContext, C as SupportApiException, M as SupportApiProvider, f as SupportClient, E as SupportRoute, b as UpdateCampaignStatusCampaignDetailsCurrentStage, x as UpdateCampaignStatusRequestStage, S as UpdateCampaignStatusStageOptionStage, N as useGetAgentIntegrationStatus, I as useGetCommonInformationForMessage, R as useGetLogsForServiceAtPeriod, W as useGetManualDocuSignUpdateCampaignDetails, K as useGetMigrations, B as useGetPoisonQueueMessages, H as useGetPoisonQueues, X as useGetSoftDeletedAgentsForAgency, $ as useGetUpdateCampaignStatusDetails, ne as useGetUpdateLegalNameCampaignDetails, P as useInvalidateUseGetAgentIntegrationStatus, L as useInvalidateUseGetCommonInformationForMessage, z as useInvalidateUseGetLogsForServiceAtPeriod, G as useInvalidateUseGetManualDocuSignUpdateCampaignDetails, q as useInvalidateUseGetMigrations, V as useInvalidateUseGetPoisonQueueMessages, U as useInvalidateUseGetPoisonQueues, Z as useInvalidateUseGetSoftDeletedAgentsForAgency, ee as useInvalidateUseGetUpdateCampaignStatusDetails, re as useInvalidateUseGetUpdateLegalNameCampaignDetails, Y as useReplayQueueMessage, F as useResetAgentIntegration, Q as useRestoreSoftDeletedAgent, J as useStartMigrationRun, A as useSupportClientContext, te as useUpdateCampaignStatus, ie as useUpdateVendorLegalName };
